import { useQuery } from "@tanstack/react-query";

import { analyticsApi } from "~/store/initializeStore";

import { type MarketingDashboardFilters, toMarketingRequestParams } from "../marketingFilters";

/** Mirrors analytics-service GetMarketingCampaignsUseCase.MarketingCampaignRow. */
export interface MarketingCampaignRow {
  campaignId: string | null;
  campaignName: string;
  spend: number;
  bookingsTotal: number;
  bookingsPast: number;
  bookingsFuture: number;
  showed: number;
  srPercent: number | null;
  costPerBooking: number | null;
  costPerShow: number | null;
  sales: number;
  contractedValue: number;
  roas: number | null;
  cac: number | null;
}

const fetchCampaigns = async (filters: MarketingDashboardFilters) => {
  const response = await analyticsApi.get<MarketingCampaignRow[]>("/marketing/campaigns", {
    params: toMarketingRequestParams(filters),
  });
  return response.data;
};

export const useMarketingCampaigns = (filters: MarketingDashboardFilters) => {
  const { data, error, isLoading, isFetching } = useQuery(
    ["marketingCampaigns", filters.from, filters.to, filters.campaign, filters.rep],
    {
      keepPreviousData: true,
      queryFn: () => fetchCampaigns(filters),
    },
  );

  return { campaigns: data ?? [], error, isLoading, isFetching };
};
